var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#notification_svg__clip0_3710_56557)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18v.75a3 3 0 006 0V18M13 3.076a6.665 6.665 0 00-3.546.427A6.74 6.74 0 005.269 9.75v.75c0 3.356-.703 5.306-1.322 6.375A.75.75 0 004.594 18h14.812a.75.75 0 00.647-1.125c-.554-.958-1.177-2.623-1.3-5.375",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 4,
    fill: "#EB0045"
  }))));
}
export default SvgNotification;